var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    stroke: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6379",
    "data-name": "Rectangle 6379",
    width: 52,
    height: 52,
    transform: "translate(-20141 -4819)",
    fill: "#FF6B5B",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_de_masques_16285",
    "data-name": "Groupe de masques 16285",
    transform: "translate(20141 4819)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "credit-card",
    transform: "translate(-20141 -4818.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11727",
    "data-name": "Trac\\xE9 11727",
    d: "M45.945,10.954a.661.661,0,0,0,1.321,0,4.009,4.009,0,0,0-4-4H4a4.009,4.009,0,0,0-4,4v25.3a4.009,4.009,0,0,0,4,4H26.367a.657.657,0,0,0,.661-.661.617.617,0,0,0-.661-.661H4a2.662,2.662,0,0,1-2.661-2.661V10.954A2.662,2.662,0,0,1,4,8.294H43.284a2.662,2.662,0,0,1,2.661,2.661Z",
    fill: "#FF6B5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11728",
    "data-name": "Trac\\xE9 11728",
    d: "M31.835,14.954a.617.617,0,0,0-.661-.661H8.661a.661.661,0,0,0,0,1.321h22.5A.641.641,0,0,0,31.835,14.954Z",
    fill: "#FF6B5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11729",
    "data-name": "Trac\\xE9 11729",
    d: "M30.642,18.936a.617.617,0,0,0-.661-.661H8.661a.661.661,0,1,0,0,1.321h21.3A.622.622,0,0,0,30.642,18.936Z",
    fill: "#FF6B5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11730",
    "data-name": "Trac\\xE9 11730",
    d: "M8.661,30.257a.661.661,0,0,0,0,1.321h6.661a.661.661,0,0,0,0-1.321Z",
    fill: "#FF6B5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11731",
    "data-name": "Trac\\xE9 11731",
    d: "M48.018,22.33a.71.71,0,0,0,.661-.661V19.743a7.982,7.982,0,1,0-15.963,0V21.67a.661.661,0,1,0,1.321,0V19.743a6.661,6.661,0,1,1,13.321,0V21.67a.608.608,0,0,0,.661.661Z",
    fill: "#FF6B5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11732",
    "data-name": "Trac\\xE9 11732",
    d: "M40.7,29.927a2.548,2.548,0,0,0-1.725,4.459v1.468a1.74,1.74,0,0,0,1.725,1.8,1.876,1.876,0,0,0,1.8-1.8V34.385a2.7,2.7,0,0,0,.862-1.872A2.612,2.612,0,0,0,40.7,29.927Zm.734,3.651a.584.584,0,0,0-.257.532v1.8a.407.407,0,1,1-.807,0v-1.8a.816.816,0,0,0-.257-.532,1.282,1.282,0,0,1-.661-.991,1.268,1.268,0,0,1,1.266-1.266,1.353,1.353,0,0,1,1.321,1.266,1.512,1.512,0,0,1-.606.991Z",
    fill: "#FF6B5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11733",
    "data-name": "Trac\\xE9 11733",
    d: "M49.138,23.67H32.165A2.843,2.843,0,0,0,29.3,26.532V40.771a2.843,2.843,0,0,0,2.862,2.862H49.138A2.894,2.894,0,0,0,52,40.7V26.514a2.839,2.839,0,0,0-2.862-2.844Zm1.541,17.046a1.543,1.543,0,0,1-1.523,1.523H32.183a1.5,1.5,0,0,1-1.523-1.523V26.532a1.543,1.543,0,0,1,1.523-1.523H49.156a1.5,1.5,0,0,1,1.523,1.523Z",
    fill: "#FF6B5B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.88c5eb4ac4742e6b4234b75a20d13c48.svg";
export { ForwardRef as ReactComponent };